export function calculateNextUnreadableSequence(lastReadMessageSequence, roomMessages, userId) {
    var unreadableMessages = roomMessages.filter(function (m) {
        var _a;
        return !m.isSilent &&
            (!lastReadMessageSequence || m.sequence <= lastReadMessageSequence) &&
            ((_a = m.sender) === null || _a === void 0 ? void 0 : _a.userId) !== userId;
    });
    if (unreadableMessages.length > 0) {
        return unreadableMessages[unreadableMessages.length - 1].sequence - 1;
    }
}
